"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ListCard_1 = require("../../card/ListCard");
const assets_1 = require("../../config/assets");
const config_1 = require("../../config/config");
const ActivityListItem = ({ activity, isPlayForFunOnly = false, isInformationOnly = false, onPress }) => {
    const { extraData } = activity;
    const cardTitle = extraData ? extraData.find(item => item.key === 'cardTitle') : null;
    let image;
    if (isInformationOnly) {
        image = assets_1.assets.internalAssets.starImg;
    }
    else if (activity.isBonus) {
        image = assets_1.assets.internalAssets.bonusIcon;
    }
    else {
        image = undefined;
    }
    const cornerIcon = {
        icon: isInformationOnly || activity.isBonus ? undefined : 'icon-earn',
        iconType: 'custom',
        contentColor: config_1.config.themeColors.cornerColors.activityContrast.hex(),
        trianglePosition: { top: 0, left: 0 },
        triangleType: 'topLeft',
        triangleBackgroundColor: isInformationOnly
            ? config_1.config.themeColors.white.hex()
            : config_1.config.themeColors.cornerColors.activity.hex(),
        triangleSize: 88,
        image
    };
    let title = 'EARN POINTS';
    if (activity.isBonus === true) {
        title = 'EARN BONUS';
    }
    else if (isPlayForFunOnly) {
        title = 'EARN 0 POINTS';
    }
    else if (activity.amount && activity.amount > 0) {
        title = `EARN ${activity.amount.toPointsFormatWithUnit().toUpperCase()}`;
    }
    else if (isInformationOnly) {
        title = `SPECIAL OFFERS!`;
    }
    title = cardTitle ? cardTitle.value : title;
    return ((0, jsx_runtime_1.jsx)(ListCard_1.default, { image: activity.imageUrl, imageTitle: `${activity.title}`, text: activity.title, title: title, titleColor: 'primary', cornerIcon: cornerIcon, onClick: onPress, bonusPoints: activity.bonusAmount ? activity.bonusAmount + activity.amount : undefined, noneBonusPoints: activity.amount, disableCornerIcon: config_1.config.internalConfig.DISABLE_EARN_CORNER_ICON }));
};
exports.default = ActivityListItem;
//# sourceMappingURL=ActivityListItem.js.map